import React from 'react';
import { Container, DiaSemana, DiaAbreviado, DiaNumero, DataCompleta, DataTexto, QuantidadeDemandas } from './styles';

interface CabecalhoDiaListaDemandasProps {
  data: Date;
  qtdDemandas: number;
}

export default function CabecalhoDiaListaDemandas({ data, qtdDemandas }: CabecalhoDiaListaDemandasProps) {
  const obterDiaSemana = (data: Date): string => {
    const diasSemana = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];
    return diasSemana[data.getDay()];
  };

  const obterDiaMes = (data: Date): string => {
    return data.getDate().toString().padStart(2, '0');
  };

  const formatarDataCompleta = (data: Date): string => {
    return data.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      weekday: 'long'
    });
  };

  return (
    <Container>
      <DiaSemana>
        <DiaAbreviado>{obterDiaSemana(data)}</DiaAbreviado>
        <DiaNumero>{obterDiaMes(data)}</DiaNumero>
      </DiaSemana>
      <DataCompleta>
        <DataTexto>{formatarDataCompleta(data)}</DataTexto>
        <QuantidadeDemandas>{qtdDemandas} demanda{qtdDemandas !== 1 ? 's' : ''}</QuantidadeDemandas>
      </DataCompleta>
    </Container>
  );
}
